import { Controller } from "@hotwired/stimulus"
import { navigateSelectOnChange } from "../src/navigation"

export default class extends Controller {
  selectionChanged(ev) {
    navigateSelectOnChange(ev.currentTarget)
  }
}
